import { getSignInAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function signIn(email, password) {
    try {
        await getSignInAuth().signIn(email.toLowerCase(), password);
        return {};
    }
    catch (error) {
        return throwClientError(error, { provider: 'basic' });
    }
}
